export default {
    create() {
        return {
            golfsetUuids: [],
            buggies: 0,
            trolleys: 0,
            golfsets: [],
        };
    },
};
